//Serviços.js
import React from 'react'
import { Text, View } from 'react-native'
import styles from './Styles.js'

//const border = 1;

const Serviços = () => {
  return (
    <View>
      <Text style={styles.titleText}>Serviços</Text>
      <Text style={styles.baseText}>Tutoria</Text>
      <Text></Text>
      <Text style={styles.baseText}>Aulas particulares</Text>
      <Text></Text>
      <Text style={styles.baseText}>Acompanhamento escolar</Text>
      <Text></Text>
      <Text style={styles.baseText}>Aconselhamento de carreiras</Text>
      <Text></Text>
      <Text style={styles.baseText}>Preparação para provas</Text>
      <Text> </Text>
      <Text> </Text>
    </View>
  )
};
export default Serviços;
